export type FeatureCategory =
  | "Search & Discovery"
  | "Business Insights"
  | "Saving & Organization"
  | "Research Tools"
  | "Maps & Routes";

export interface PlanFeature {
  id: string;
  category: FeatureCategory;
  feature: string;
  description: string;
  free: string | boolean;
  pro: string | boolean;
  highlight: boolean;
}

export const PLAN_CATEGORIES: FeatureCategory[] = [
  "Search & Discovery",
  "Business Insights",
  "Saving & Organization",
  "Research Tools",
  "Maps & Routes"
];

export const AUDITED_PLAN_FEATURES: PlanFeature[] = [
  // --- PRIMARY HIGHLIGHTS (highlight: true) ---
  {
    id: "search_filters",
    category: "Search & Discovery",
    feature: "Search & Lead Filters",
    description: "Filter leads by hiring signals, review count, rating ranges, and category depth.",
    free: "Standard set",
    pro: "Expanded set",
    highlight: true
  },
  {
    id: "opportunity_insights",
    category: "Business Insights",
    feature: "Opportunity Insights & Tags",
    description: "Categorized badges identifying hiring needs, website gaps, and business reputation signals.",
    free: "Standard selection",
    pro: "Expanded selection",
    highlight: true
  },
  {
    id: "saved_businesses",
    category: "Saving & Organization",
    feature: "Saved Businesses Storage",
    description: "Maximum number of saved business profiles stored in your workspace.",
    free: "Up to 25 businesses",
    pro: "Unlimited (9,999 total)",
    highlight: true
  },
  {
    id: "contact_crawl",
    category: "Research Tools",
    feature: "Contact Research Crawler",
    description: "Extract public business emails, decision-maker phone numbers, and contact links.",
    free: "15 searches / week",
    pro: "Unlimited (9,999/wk)",
    highlight: true
  },
  {
    id: "website_audit",
    category: "Research Tools",
    feature: "Website & SEO Health Audits",
    description: "Analyze mobile responsiveness, HTTPS security, contact forms, and booking tools.",
    free: "15 audits / week",
    pro: "Unlimited (9,999/wk)",
    highlight: true
  },
  {
    id: "csv_export",
    category: "Saving & Organization",
    feature: "Client-Side CSV Data Export",
    description: "Export filtered search results and saved lead lists directly to downloadable CSV files.",
    free: false,
    pro: true,
    highlight: true
  },
  {
    id: "route_optimizer",
    category: "Maps & Routes",
    feature: "Driving Route Planning",
    description: "Calculate nearest-first driving routes across saved leads to minimize physical travel time.",
    free: "Standard directions",
    pro: "Nearest-first optimization",
    highlight: true
  },
  {
    id: "crm_pipeline",
    category: "Saving & Organization",
    feature: "Interactive Kanban CRM Board",
    description: "Drag-and-drop leads across deal stages (New, Contacted, Interested, Won, Lost).",
    free: false,
    pro: true,
    highlight: true
  },
  {
    id: "followup_planner",
    category: "Saving & Organization",
    feature: "Follow-Up Schedule Planner",
    description: "Schedule callback dates, track overdue touchpoint deadlines, and manage reminders.",
    free: "Basic notes",
    pro: "Visual calendar & alerts",
    highlight: true
  }
];
